
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "layout": "post",
  "title": "Long Exposure Under the Ben Franklin",
  "date": "2014-09-20 12",
  "comments": "true",
  "categories": "[\"photo\", \"philadelphia\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "created": "2014-09-20",
  "tags": [
    "photo",
    "philadelphia"
  ],
  "draft": false
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":["We rode the bikes down to the Fringe Arts building at Columbus and Race, which is also the home to a new restaurant, La Peg. It rests under the Ben Franklin Bridge, and has an outdoor bar built inside a shipping container (a requirement for all the hip popups these days)."]},"\n",{"type":"p","props":{},"children":["f/11, 3.7s, ISO800\n",{"type":"img","props":{"src":"/static/images/posts/20140919-DSCF0938.jpg","alt":"looonnggg"}}]},"\n",{"type":"p","props":{},"children":[{"type":"img","props":{"src":"/static/images/posts/20140919-DSCF0936.jpg","alt":"again"}}]}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
